const fields = {
    EMAIL: 'email',
};

export default fields;
